import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { getCurrentMaturityIndexForItems } from "product-test-utils";

import { DashboardCardContext } from "../context";

export function addAverageProjectMaturityCard(ctx: DashboardCardContext) {
  const { view, language } = ctx;

  const averageProjectMaturityComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "averageProjectMaturityComponent",
      labels: ["maturity", "average", "projects"],
      title:
        getLocalizedMessage(language, "cards.averageOeMaturityLevel.title") ||
        "Average OE Maturity",
      description:
        getLocalizedMessage(
          language,
          "cards.averageOeMaturityLevel.description"
        ) || "Shows the mathematical average maturity across all OEs.",
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  averageProjectMaturityComponent.mapState(
    ({ dashboard, settings, language }) => {
      const projects = dashboard?.projects ?? [];
      const maturityValues = projects.map((project) =>
        getCurrentMaturityIndexForItems(
          project.reportingItems ?? [],
          settings?.configuration
        )
      );

      const averageMaturity =
        maturityValues.length > 0
          ? maturityValues.reduce((sum, value) => sum + value, 0) /
            maturityValues.length
          : 0;

      return {
        showInfoIcon: false,
        showMenuIcon: false,
        title:
          getLocalizedMessage(language, "cards.averageOeMaturityLevel.title") ||
          "Average OE Maturity",
        description:
          getLocalizedMessage(
            language,
            "cards.averageOeMaturityLevel.description"
          ) || "Shows the mathematical average maturity across all OEs.",
        number: averageMaturity.toFixed(2),
      };
    }
  );

  averageProjectMaturityComponent.mapVisibility(({ settings }) => {
    return settings?.configuration?.useCase === "maturity";
  });
}
